import type { Locale } from '@webcatalog/lexibird-constants/locales';

import { requireI18nContext } from '~lexibird-marketing/utils/require-i18n-context';

export const getLocale = (): Locale => requireI18nContext().locale;
